import './LiksCard.css';

export type LiksCardProps = {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
};

export function LiksCard({
  title,
  description,
  children,
  className,
}: LiksCardProps) {
  return (
    <section className={['liks-card', className].filter(Boolean).join(' ')}>
      <div className="liks-card__content">
        <h2 className="liks-card__title">{title}</h2>
        {description != null && (
          <p className="liks-card__description">{description}</p>
        )}
      </div>
      <div className="liks-card__actions">{children}</div>
    </section>
  );
}
